import React, { useState } from 'react'

import Card from '../components/UI/Card';

import useInput from '../hooks/useInput';

import { MdArrowBackIos, MdArrowForward } from "react-icons/md";

import logo from '../assets/logoufm1.png';
import axios from 'axios';
import { Link } from 'react-router-dom';


const PasswordRecovery = () => {

    const [error, setError] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    // INPUT EMAIL
    const emailValidacion = value => {
        const emailRE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRE.test(value);
    };
    const {
        value: email,
        isValid: emailIsValid,
        isTouched: emailIsTouched,
        divInput: divEmail,
        valueChangeHandler: emailChangeHanlder,
        inputBlurHandler: emailBlurHandler
    } = useInput(emailValidacion);

    const formSubmitHandler = async event => {
        event.preventDefault();

        emailBlurHandler();

        if(!emailIsValid)
            return;

        let formData = new FormData();
        formData.append('email', email);
        formData.append('recuperacionPassword', 1);

        const response = await axios.post(process.env.REACT_APP_API_URL, formData);
        const result = response.data;
        
        if( result.STATUS && result.STATUS === "SUCCESS" ){
            setError(false);
            setEmailSent(true);
        } else {
            setError(true);
        }
    }

    return (
        <div className="row">
            <div className="offset-md-3 col-md-6">
                <Card>
                    <form className="row my-4" onSubmit={formSubmitHandler}>

                        {/* LOGO */}
                        <div className="col-md-12 text-center my-3">
                            <img src={logo} alt="logo-ufm" style={{height: '5.5rem'}} />
                        </div>

                        {/* LABEL TITULO */}
                        <div className="col-md-8 offset-md-2 mb-1">
                            <h1 className="display-6 mb-0" style={{ userSelect: 'none', color: 'rgba(0,0,0,0.65)', fontSize: '1.5rem' }}>Recuperación de contraseña</h1>
                        </div>

                        <div className="col-md-8 offset-md-2"><hr className="mt-0" /></div>

                        {/* ERROR */}
                        {
                            error && 
                            <div className="col-md-8 offset-md-2">
                                <div className="alert alert-danger">
                                    <h5 className="alert-heading">¡Error!</h5>
                                    Ocurrió un problema, intentelo de nuevo más tarde.
                                </div>
                            </div>
                        }

                        {
                            emailSent && 
                            <div className="col-md-8 offset-md-2 text-black-50" style={{ userSelect: 'none' }}>
                                <p>Se envió un link de recuperación de contraseña a su correo electrónico.</p>
                                <p>Verifique su bandeja de entrada.</p>
                                <div className="text-center py-4">
                                    <Link to='/login' className="btn btn-success shadow" style={{fontWeight: "500"}} >
                                        <MdArrowBackIos/> Volver a login
                                    </Link>
                                </div>
                            </div>
                        }

                        {
                            !emailSent &&
                            <>
                                {/* EMAIL */}
                                <div className="col-md-8 offset-md-2 mb-3 mt-1" ref={divEmail}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Correo electrónico</label>
                                    <input 
                                        type="email" 
                                        name="email"
                                        className={`form-control form-control-sm shadow-sm ${emailIsTouched ? ((emailIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={email}
                                        onChange={emailChangeHanlder}
                                        onBlur={emailBlurHandler}
                                        placeholder="ejemplo@gmail.com" />
                                    <div className="form-text">Recibirá un correo electrónico con instrucciones para reestablecer su contraseña. *Revise la bandeja de correo no deseado (spam).</div>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Debe ingresar un correo electrónico
                                    </div>
                                </div>

                                {/* BUTTONS */}
                                <div className="col-md-8 offset-md-2 my-3 text-center">
                                    <button
                                        className={`btn btn-success btn-sm`}>
                                        <span style={{display: 'flex'}}>
                                            Enviar&nbsp;<MdArrowForward className="my-1" />
                                        </span>
                                    </button>
                                </div>
                            </>
                        }
                    </form>
                </Card>
            </div>
        </div>
    )
}

export default PasswordRecovery;